export default __webpack_public_path__ + "static/media/rabbit39.077f4c10.gif";